import { render, staticRenderFns } from "./gSwiperCommon.vue?vue&type=template&id=10b2ee88&scoped=true"
import script from "./gSwiperCommon.vue?vue&type=script&lang=js"
export * from "./gSwiperCommon.vue?vue&type=script&lang=js"
import style0 from "./gSwiperCommon.vue?vue&type=style&index=0&id=10b2ee88&prod&lang=scss"
import style1 from "./gSwiperCommon.vue?vue&type=style&index=1&id=10b2ee88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b2ee88",
  null
  
)

export default component.exports